import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledMetadataSkeleton = styled("div")(({ theme }) => ({
    maxWidth: "80%",
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    marginBottom: theme.spacing(2),
}));

const StyledWrapper = styled("div")(({ theme }) => ({
    paddingBottom: theme.spacing(1),
    display: "flex",
}));

const StyledInnerWrapper = styled("div")(({ theme }) => ({
    marginLeft: theme.spacing(2),
    width: "100%",
}));

/**
 * media page lobby data(presenters) skeleton
 */
export function DataSkeleton() {
    const theme = useTheme();

    return (
        <StyledMetadataSkeleton>
            <StyledWrapper>
                <StyledSkeleton variant="rectangular" height={theme.spacing(6)} width={theme.spacing(6)} />

                <StyledInnerWrapper>
                    <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"20%"} />

                    <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"10%"} />
                </StyledInnerWrapper>
            </StyledWrapper>

            <StyledWrapper>
                <StyledSkeleton variant="rectangular" height={theme.spacing(6)} width={theme.spacing(6)} />

                <StyledInnerWrapper>
                    <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"20%"} />

                    <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"10%"} />
                </StyledInnerWrapper>
            </StyledWrapper>
        </StyledMetadataSkeleton>
    );
}

export default DataSkeleton;
